(() => {
  function revealNearbyImages() {
    const hydrate = image => {
      if (image.dataset.amNearSrcset) image.srcset = image.dataset.amNearSrcset;
      image.src = image.dataset.amNearSrc;
      delete image.dataset.amNearSrc;
      delete image.dataset.amNearSrcset;
    };
    const images = document.querySelectorAll('img[data-am-near-src]');
    if (!('IntersectionObserver' in window)) { images.forEach(hydrate); return; }
    const observer = new IntersectionObserver(entries => {
      for (const entry of entries) if (entry.isIntersecting) {
        hydrate(entry.target);
        observer.unobserve(entry.target);
      }
    }, {rootMargin:'200px'});
    images.forEach(image => observer.observe(image));
  }
  revealNearbyImages();
  function mount(root) {
    const slider = root.querySelector('.hero-banner-horizontal__wrapper');
    if (!slider || slider.dataset.amMediaReady) return;
    slider.dataset.amMediaReady = 'true';
    const slides = [...slider.querySelectorAll('.slider-container > .slide-item')];
    const pending = new Map();
    function load(index, priority = 'low') {
      const slide = slides[(index + slides.length) % slides.length];
      if (!slide) return Promise.resolve();
      const image = slide.querySelector('img.am-hero-image');
      if (!image) return Promise.resolve();
      if (priority === 'high') image.fetchPriority = 'high';
      if (pending.has(image)) return pending.get(image);
      const request = (async () => {
        if (image.dataset.amHeroSrc) {
          slide.querySelectorAll('source[data-am-hero-srcset]').forEach(source => {
            source.srcset = source.dataset.amHeroSrcset;
            delete source.dataset.amHeroSrcset;
          });
          image.loading = 'eager';
          image.srcset = image.dataset.amHeroSrcset;
          image.src = image.dataset.amHeroSrc;
          delete image.dataset.amHeroSrc;
          delete image.dataset.amHeroSrcset;
        }
        try { await image.decode(); } catch {}
      })();
      pending.set(image, request);
      return request;
    }
    let last = -1, firstPainted = false;
    function active() {
      const index = slides.findIndex(slide => slide.classList.contains('is-active'));
      if (index < 0 || index === last) return;
      last = index;
      load(index, 'high').then(() => { if (firstPainted || index !== 0) load(index + 1); });
      const video = slides[index].querySelector('video');
      const source = video?.querySelector('source[data-am-hero-video-src]');
      if (video && source && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
        source.src = source.dataset.amHeroVideoSrc;
        delete source.dataset.amHeroVideoSrc;
        video.addEventListener('loadeddata', () => { video.style.opacity = '1'; }, {once:true});
        video.addEventListener('canplay', () => {
          const rect = video.getBoundingClientRect();
          if (slides[index].classList.contains('is-active') && !document.hidden && rect.bottom > 0 && rect.top < innerHeight) video.play().catch(() => {});
        }, {once:true});
        video.load();
      }
    }
    new MutationObserver(active).observe(slider, {subtree:true, attributes:true, attributeFilter:['class']});
    slider.addEventListener('pointerdown', event => {
      const next = event.target.closest('.slider-nav-next');
      const previous = event.target.closest('.slider-nav:not(.slider-nav-next)');
      if (next || previous) load(Math.max(0, last) + (next ? 1 : -1), 'high');
    }, {passive:true});
    load(0, 'high').then(() => {
      requestAnimationFrame(() => requestAnimationFrame(async () => {
        firstPainted = true;
        const order = [1, slides.length - 1, ...slides.map((_, i) => i).slice(2, -1)];
        for (const index of order) {
          if (!slider.isConnected) break;
          await load(index);
        }
      }));
    });
    active();
  }
  document.querySelectorAll('.section-hero-slideshow-horizontal').forEach(mount);
  document.addEventListener('shopify:section:load', event => { mount(event.target); revealNearbyImages(); });
})();
